import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Text, Wrap, WrapItem } from '@chakra-ui/react';

import Authorizer, { FeatureFlags } from '../../Authorizer';
import MultiSelectDropdown from '../../MultiSelectDropdown';
import MultiSelectSearchWrapper from '../../MultiSelectDropdown/MultiSelectSearchWrapper';
import SearchGlobalSearchInput from '../SearchGlobalSearchInput';

const SearchQuickFilters = ({ searchBlueprint }) => {
  const dispatch = useDispatch();
  let quickFilters = useSelector(searchBlueprint.selectQuickFilterOptions);
  return (
    <>
      <Text color="greyScale.700" mb={4}>Quick Filters</Text>
      <Wrap flexBasis="100%" justify="space-between" maxW="80%" minW="1000px">
        <Authorizer featureFlag={FeatureFlags.Codes}>
          {({
            authorized,
            authorizedFeatureFlags
          }) => {
            if (!authorized) return null;
            quickFilters = quickFilters.filter(option => (option?.flag
              ? authorizedFeatureFlags.includes(option.flag) : true));

            return (
              quickFilters.map(filter => (
                <WrapItem key={filter.name} minW="49%" my={4}>
                  {filter?.searchBlueprint
                    ? (
                      <MultiSelectSearchWrapper
                        formatDataFunction={filter.transformFunction}
                        idKey={filter.idKey}
                        labelKey={filter.labelKey}
                        minWidth="100%"
                        popoverId={`${filter.name}-quick-filters`}
                        searchBlueprint={filter.searchBlueprint}
                        searchComponent={() => <SearchGlobalSearchInput searchBlueprint={filter.searchBlueprint} width="450px" />}
                        selectedValues={filter.selected}
                        title={filter.placeholder}
                        onChange={selected => dispatch(searchBlueprint.updateQuickFilters(filter.name, selected))}
                      />
                    )
                    : (
                      <MultiSelectDropdown
                        data={filter.data}
                        idKey={filter.idKey}
                        labelKey={filter.labelKey}
                        placeholder={filter.placeholder}
                        popoverId={`${filter.name}-quick-filters`}
                        values={filter.selected}
                        onChange={selected => dispatch(searchBlueprint.updateQuickFilters(filter.name, selected))}
                      />
                    )}
                </WrapItem>
              ))
            );
          }}
        </Authorizer>
      </Wrap>
    </>
  );
};

export default SearchQuickFilters;
